import "./TabsGlossaryV2.scss";
import clsx from "clsx";
import React, { PropsWithChildren, ReactNode } from "react";
import { Loader, Row } from "@/components";

type TabItem = {
  label: string;
  disabled?: boolean;
};

type ActionItem = PropsWithChildren<{
  label: string;
  icon: ReactNode;
  onClick: () => void;
  loading?: boolean;
}>;

type TabsGlossaryV2Props = {
  CTA?: "link" | "primary";
  navigationItems: TabItem[];
  activeIndex: number;
  onTabChange: (index: number) => void;
  actions?: ActionItem[];
  children?: ReactNode;
};

export const TabsGlossaryV2 = ({
  CTA = "link",
  navigationItems,
  children,
  activeIndex = 0,
  onTabChange,
  actions = [],
}: TabsGlossaryV2Props) => (
    <div>
      <div className="ui-document-container-tabs-v2">
        <nav
          className="ui-document-container-tabs-nav-new-v2"
          aria-label="Menu di navigazione"
        >
          <Row
            fw="semibold"
            text="secondary"
            className="ui-document-container-tabs-nav-v2 list-style-none ui-tabs-v2"
            as="ul"
            role="tablist"
          >
            {navigationItems.map((item, index) => (
              <li
                key={index}
                className={clsx(
                  "ui-document-container-tabs-nav-responsive-flex-v2 ui-text-center-col-v2 fs-6 md-fs-custom",
                  item.disabled && "text-muted",
                  "ui-tab-v2",
                  activeIndex === index && "text-primary ui-active-tab-glossary-v2",
                )}
                role="presentation"
              >
                <button
                  type="button"
                  role="tab"
                  aria-selected={activeIndex === index}
                  aria-disabled={item.disabled}
                  tabIndex={item.disabled ? -1 : 0}
                  className={clsx(
                    "ui-tab-button-v2 text-decoration-none",
                    !item.disabled && "cursor-pointer",
                  )}
                  disabled={item.disabled}
                  onClick={() => {
                    if (!item.disabled) onTabChange(index);
                  }}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </Row>
        </nav>
        {children}
        {CTA === "link" && (
          <nav className="ui-document-container-tabs-nav-new-v2">
            <ul className="list-style-none base-row gap-x20 fw-semibold text-primary fs-7 pb-x8">
              {actions.map((action, index) => (
                <React.Fragment key={index}>
                  <li>
                    <button
                      type="button"
                      className={clsx(
                        "ui-tab-action-v2 text-primary base-row justify-content-center align-items-center gap-x8",
                        !action.loading && "cursor-pointer",
                      )}
                      disabled={action.loading}
                      onClick={action.onClick}
                    >
                      {action.icon}
                      <p>{action.label}</p>
                      {action.loading && <Loader loading={action.loading} />}
                    </button>
                  </li>
                  {index < actions.length - 1 && (
                    <li>
                      <span className="ui-divider-v2"></span>
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </div>
);
